import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';
import { fromJS, Record } from 'immutable';

export const XERO_TAX_SCHEMA = Object.freeze({
  TAX_NAME: '',
  TAX_TYPE: '',
  TAX_RATE: null,
});

const RECORD = generateSchema(XERO_TAX_SCHEMA);
const KEYS: any = generateKeys(XERO_TAX_SCHEMA);

export class XeroTax extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get taxName(): string {
    return this.get(KEYS.TAX_NAME);
  }

  get taxType(): string {
    return this.get(KEYS.TAX_TYPE);
  }

  get taxRate(): number {
    return this.get(KEYS.TAX_RATE);
  }
}
